<h4 class="strong">Order Details:</h4>
@if (vm$ | async; as vm) {
  <div>
    <table class="table table-custom-light">
      <thead class="table-light">
        @if (!(vm.orderHistoryDeliveryEnabled)) {
          <tr>
            <th style="width: 25%;">Part Number</th>
            <th style="width: 45%;">Item Description</th>
            <th style="width: 10%;" class="text-center">Price</th>
            <th style="width: 10%;" class="text-center">Quantity</th>
            <th style="width: 10%;" class="text-center">Total</th>
          </tr>
        } @else {
          <tr>
            <th>Part Number</th>
            <th>Item Description</th>
            <th class="text-center">Price</th>
            <th class="text-center">Quantity</th>
            <th class="text-center">Total</th>
            <th class="text-center">Delivery Method</th>
            <th>
              <div class="d-flex align-items-start">
                <div style="margin-top: 0rem; margin-right: 1rem;" class="text-center">Delivery Status</div>
                <div ngbDropdown autoClose="outside" display="dynamic" placement="bottom-right">
                  <button class="btn border border-secondary" ngbDropdownToggle>
                    <i class="fa-filter" [ngClass]="{ 'fas': vm.deliveryStatusFilterApplied, 'far': !vm.deliveryStatusFilterApplied }"></i>
                  </button>
                  <order-line-items-delivery-status-filter ngbDropdownMenu [deliveryStatusOptions]="vm.deliveryStatusOptions" [isInternalUser$]="isInternal$" ngModel (ngModelChange)="deliveryStatusFilterChange($event)"></order-line-items-delivery-status-filter>
                </div>
              </div>
            </th>
          </tr>
        }
      </thead>
      @if (vm.orderDetails) {
        <tbody>
          @for (item of vm.lineItems; track item; let i = $index) {
            @if (item.partNumber !== 'FREIGHT' && item.partNumber !== 'DELIVERY:90') {
              <tr id="orderDetailsTable_tr_lineItem_{{i}}">
                <td class="text-truncate" [title]="item.partNumber">{{ item.partNumber }}</td>
                <td class="text-truncate order-details-table-item-description" [title]="item.description">{{ item.description }}</td>
                <td class="text-end">{{ item.unitPrice | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item.quantity | number:'.0' }}</td>
                <td class="text-end">{{ (item.quantity * item.unitPrice) | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
                <td class="text-truncate" [title]="item.partNumber">{{ DeliveryMethodsLookup[item.deliveryOption] }}</td>
                @if (vm.orderHistoryDeliveryEnabled) {
                  <td >{{ item.deliveryStatusLabel }}</td>
                }
              </tr>
            }
            @for (coupon of item.sapCoupons; track coupon) {
              <tr id="orderDetails_tr_lineItem{{i}}_coupon{{j}}">
                <td></td>
                <td>{{ coupon.description }}</td>
                <td colspan="2"></td>
                <td class="text-end">{{ coupon.amount | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
                @if (vm.orderHistoryDeliveryEnabled) {
                  <td></td>
                }
              </tr>
            }
          }
        </tbody>
      }
      @if (vm.orderDetails) {
        <tbody class="table-borderless" style="border-top: 1px solid #ccc;">
          <tr>
            <td colspan="2"></td>
            <td colspan="2" class="strong text-end">Subtotal</td>
            <td class="text-end">{{ vm.subtotal | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            @if (vm.orderHistoryDeliveryEnabled) {
              <td></td>
            }
          </tr>
          @if (vm.freightLinesPrice > 0) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Freight</td>
              <td class="text-right">{{vm.freightLinesPrice | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
          }
          @if (vm.freight > 0) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Freight</td>
              <td class="text-right">{{vm.freight | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
          }
          @if (vm.deliveryLinesPrice > 0) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Delivery</td>
              <td class="text-right">{{vm.deliveryLinesPrice | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
          }
          @if (vm.delivery > 0) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Delivery</td>
              <td class="text-right">{{vm.delivery | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
          }
          @if (vm.deliveryFee !== 0) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Retail Delivery Fee</td>
              <td class="text-right">{{ vm.deliveryFee | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
            @if (vm.deliveryFeeCredit !== 0) {
              <tr>
                <td colspan="2"></td>
                <td colspan="2" class="text-right">Delivery Fee Credit</td>
                <td class="text-right">{{ vm.deliveryFeeCredit | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
              </tr>
            }
          }
          @if (vm.bagFee !== 0 && vm.bagFeesEnabled) {
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right">Bag Fee</td>
              <td class="text-right">{{ vm.bagFee | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            </tr>
          }
          @if (vm.orderDetails.cartCouponTotal) {
            <tr class="table-borderless">
              <td colspan="2"></td>
              <td colspan="2" class="strong text-end">Cart Coupons</td>
              <td class="text-end">{{ vm.orderDetails.cartCouponTotal | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
              @if (vm.orderHistoryDeliveryEnabled) {
                <td></td>
              }
            </tr>
          }
          <tr>
            <td colspan="2"></td>
            <td colspan="2" class="text-end">Estimated Sales Tax</td>
            <td class="text-end">{{ vm.orderDetails.orderHistory.tax | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            @if (vm.orderHistoryDeliveryEnabled) {
              <td></td>
            }
          </tr>
          <tr>
            <td colspan="2"></td>
            <td colspan="2" class="strong text-right">Total*</td>
            @if (total$ | async; as total) {
              <td class="text-right">{{ total | currency: vm.currencyCode :'symbol':'1.2-2' }}</td>
            }
            @if (vm.orderHistoryDeliveryEnabled) {
              <td class="text-right">
                @if (vm.deliveryStatusFilterApplied) {
                  <ng-container *ngLet="vm.filterResultTotals">
                    (showing {{vm.filterResultTotals.lineItemCount}} of {{vm.filterResultTotals.unfilteredLineItemCount}} results)
                  </ng-container>
                }
              </td>
            }
          </tr>
        </tbody>
      }
    </table>
    <br/>
    @if (vm.totalSavings) {
      <div class="text-end">
        <div class="fw-bold">Your Total Savings</div>
        <div>{{ vm.totalSavings | currency: vm.currencyCode :'symbol':'1.2-2' }}</div>
      </div>
    }
  </div>
}
